// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'tribox';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M3.712 11.621v-1.09c0-.612.474-1.088 1.085-1.088h8.474c.61 0 1.085.476 1.085 1.089v1.09M9 6.31v3.063M2.085 11.62H5.27c.61 0 1.085.477 1.085 1.09v3.2A1.073 1.073 0 0 1 5.27 17H2.085C1.475 17 1 16.523 1 15.91v-3.2c.068-.612.542-1.089 1.085-1.089zM7.44 1h3.186c.61 0 1.085.477 1.085 1.09v3.13c0 .613-.475 1.09-1.085 1.09H7.441c-.61 0-1.085-.477-1.085-1.09V1.953C6.356 1.41 6.83 1 7.44 1zm5.288 10.621h3.186c.61 0 1.085.477 1.085 1.09v3.2c0 .612-.475 1.089-1.085 1.089H12.73c-.61 0-1.085-.477-1.085-1.09v-3.2c0-.612.475-1.089 1.085-1.089z'
  />
);

export const viewBox = '0 0 18 18';
